import React from 'react'

const Home = () => {
  return (
    <div>
      Home
      Login page
    </div>
  )
}

export default Home
